import { SectionLabel } from '../ui/SectionLabel';
import { site } from '../../data/site';

export function About() {
  const { principal } = site;

  return (
    <section className="section" id="about" aria-labelledby="about-title">
      <div className="wrap about-inner">
        <div className="about-copy" data-reveal>
          <SectionLabel>About</SectionLabel>
          <h2 id="about-title">About ADCS</h2>
          <p>
            <strong>{site.name}</strong> is a South African engineering company
            specialising in control systems, high-reliability software, modelling and
            complex systems integration for aerospace and advanced engineering domains.
          </p>
          <p>
            The work spans the complete engineering path: requirements, modelling,
            estimation and control design, embedded implementation, integration and
            hardware- and software-in-the-loop verification.
          </p>
          <p>
            Experience spans Earth-observation satellites, nanosatellite platforms and
            unmanned aircraft — control-system design and implementation, flight software and
            hardware-in-the-loop verification. Several years were spent in the
            Netherlands, applying the same control and real-time software engineering
            to semiconductor lithography, electric vehicles and industrial robotics.
            Current capability also extends to distributed control and software
            integration for radio astronomy observatories.
          </p>

          <div className="industries">
            <p className="industries-label">Engineering domains and platforms</p>
            <p className="industries-list">{site.industries.join(' · ')}</p>
          </div>

          <div className="professional-experience">
            <p className="industries-label">Selected professional experience</p>
            <p>
              Alongside his work through ADCS, Dr Reddi’s broader professional experience
              includes engineering work with and in support of organizations such as{' '}
              {site.professionalExperience.join(', ')}. This experience was gained in a
              personal professional capacity and is separate from ADCS client engagements.
            </p>
          </div>
        </div>

        <aside className="principal" aria-label="Founder and principal engineer" data-reveal>
          <img
            className="principal-photo"
            src="/assets/yashren-reddi.webp"
            alt={`Portrait of ${principal.name}`}
            width={720}
            height={960}
            loading="lazy"
            decoding="async"
          />
          <div className="principal-body">
            {/* <p className="principal-label">Principal Aerospace Engineer</p> */}
            <p className="principal-name">{principal.name}</p>
            <p className="principal-role">{principal.role}</p>
            {/* <p className="principal-cred">{principal.credential}</p> */}
            <p className="principal-education">
              PhD Control Systems · University of Cape Town (2018) <br />
              MScEng Control Systems · University of KwaZulu-Natal (2012) <br />
              BScEng Electronic Engineering · University of KwaZulu-Natal (2009)
            </p>
            {/* <p className="principal-focus">{principal.focus}</p> */}
          </div>
        </aside>
      </div>
    </section>
  );
}
